import { UserProfileMenu } from "../../../../User/UserProfileMenu";

export const UpSm = () => {

	return <>
		<UserProfileMenu />
	</>
}